import { Link } from "react-router-dom";
import { WashingMachine, Mail, Phone, MapPin, Clock, ShieldCheck } from "lucide-react";
import { BUSINESS, LEGAL_PAGES } from "@/lib/legal";
import { GOOGLE_PLACE } from "@/lib/config";
import { openCookieSettings } from "@/components/CookieConsent";

const linkClass = "hover:text-cyan-400 transition-colors duration-150";

export const Footer = () => (
  <footer className="bg-slate-900 text-slate-300" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
      <div>
        <div className="flex items-center gap-2 mb-4">
          <span className="bg-cyan-500 text-white p-1.5 rounded-lg">
            <WashingMachine className="h-5 w-5" />
          </span>
          <span className="font-heading font-bold text-lg text-white notranslate">{BUSINESS.name}</span>
        </div>
        <p className="text-sm text-slate-400 max-w-xs">
          Tu lavandería del Actur: autoservicio en tienda y recogida a domicilio con pago seguro online.
        </p>
        <p className="mt-4 inline-flex items-center gap-2 text-xs text-slate-500">
          <ShieldCheck className="h-4 w-4 text-cyan-400" /> Pago seguro con Stripe · Datos protegidos (RGPD)
        </p>
      </div>
      <div>
        <h4 className="font-heading font-semibold text-white mb-4">Enlaces</h4>
        <ul className="space-y-2 text-sm">
          <li><Link to="/" className={linkClass}>Inicio</Link></li>
          <li><Link to="/reservar" className={linkClass}>Reservar Recogida</Link></li>
          <li><Link to="/seguimiento" data-testid="footer-seguimiento-link" className={linkClass}>Seguimiento de Pedido</Link></li>
          <li><Link to="/cuenta" data-testid="footer-cuenta-link" className={linkClass}>Mi cuenta</Link></li>
          <li>
            <a href={GOOGLE_PLACE.reviewUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-google-review-link" className={linkClass}>
              Déjanos una reseña en Google
            </a>
          </li>
          <li><Link to="/admin" data-testid="footer-admin-link" className={linkClass}>Panel de Administración</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="font-heading font-semibold text-white mb-4">Legal</h4>
        <ul className="space-y-2 text-sm">
          {LEGAL_PAGES.map((p) => (
            <li key={p.to}>
              <Link to={p.to} data-testid={`footer-legal-${p.to.slice(1)}`} className={linkClass}>{p.label}</Link>
            </li>
          ))}
          <li>
            <button type="button" onClick={openCookieSettings} data-testid="footer-cookie-settings-btn" className={linkClass}>
              Configurar cookies
            </button>
          </li>
        </ul>
      </div>
      <div>
        <h4 className="font-heading font-semibold text-white mb-4">Contacto</h4>
        <ul className="space-y-3 text-sm">
          <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-cyan-400 shrink-0" /> {BUSINESS.email}</li>
          <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-cyan-400 shrink-0" /> {BUSINESS.phone} (también WhatsApp)</li>
          <li className="flex items-start gap-2"><MapPin className="h-4 w-4 text-cyan-400 shrink-0 mt-0.5" /> C. de María Zayas Sotomayor, 18, 50018 Zaragoza</li>
          <li className="flex items-center gap-2"><Clock className="h-4 w-4 text-cyan-400 shrink-0" /> {BUSINESS.hours}</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-slate-800 py-4 pb-6 lg:pb-4 text-center text-xs text-slate-500 px-4">
      © {new Date().getFullYear()} <span className="notranslate">{BUSINESS.name}</span> · NIF {BUSINESS.nif} · Todos los derechos reservados.
    </div>
  </footer>
);
